/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Share_UrlInputs */

const cs_documents_share_url = /** @type {(inputs: Documents_Share_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL si zkopírujte teď — token se zobrazí jen jednou.`)
};

const en_documents_share_url = /** @type {(inputs: Documents_Share_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy this URL now — the token is shown only once.`)
};

/**
* | output |
* | --- |
* | "Copy this URL now — the token is shown only once." |
*
* @param {Documents_Share_UrlInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_share_url = /** @type {((inputs?: Documents_Share_UrlInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Share_UrlInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_share_url(inputs)
	return cs_documents_share_url(inputs)
});